export interface AnalyticsEventTypeI {
    event: string;
    pageview: string;
    set_user_id: string;
}

export interface AnalyticsEventDataI {
    category: string;
    action: string;
    label?: string;
    value?: number;
}

export interface AnalyticsProviderInterface {

    trackEvent<T extends keyof AnalyticsEventTypeI>(event_type: T, event_data: any, cb?: () => void): void;

}

export let ANALYTIC_EVENTS = {
    NEW_TRANSFER: {
        NAME: 'New transfer',
        LABEL: {
            INTERNAL: 'Between Your Accounts',
            TO_BANK_ACCOUNT: 'To Inner Client Account',
            EXTERNAL: 'External Transfer',
            DEBIT_CARD: 'Top-up Your Card',
            TO_MASTER_ACCOUNT: 'Fund Master Account',
            EXTERNAL_MASS: 'External mass payments'
        },
        ACTION: {
            CREATE: 'create',
            CONFIRM: 'confirm',
            CANCEL: 'cancel',
        }
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/analytics/analytics.provider.i.ts